import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4">
      {/* Footer Top */}
      <div className="footer-top aos" data-aos="fade-up">
        <div className="container">
          <div className="row">
            {/* Footer Contact */}
       <div className="col-lg-3">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.webp" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
        We offer a complete range of travel services including local cabs, outstation journeys, airport transfers, corporate travel, and customized packages for every travel need.
      </p>

      {/* Phone */}
      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CF191F" }}></i>
        <a href="tel:+919763381382 " style={{ color: "#fff", textDecoration: "none" }}>+91 9763381382 </a>
      </p>
   <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CF191F" }}></i>
        <a href="tel:+919011051114 " style={{ color: "#fff", textDecoration: "none" }}>+91 9011051114 </a>
      </p>
      {/* Address */}
      <p className="d-fle align-items-start text-white">
        
        <h6><i className="fas fa-map-marker-alt me-2 mt-1 " style={{ color: "#CF191F" }}></i>Ruturaj Enterprises</h6>
        Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307

      </p>



      
    </div>

<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2882.0932591951187!2d73.9581623!3d18.498549099999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c148b7268589%3A0xb12f31c0ca1f85eb!2sRuturaj%20Enterprises!5e1!3m2!1sen!2sin!4v1789471396008!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>




    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/ruturajenterprises29/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61593885995168" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/ruturaj_travels" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/ruturajenterprises/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
              
            </li>
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            

<li><Link to="/Tempo-Traveller-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller On Rent in Pune</Link></li>
<li><Link to="/Pune-to-Shirdi-Tempo-Traveller-on-Rent"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Tempo Traveller on Rent</Link></li>
<li><Link to="/Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Tempo Traveller on Rent</Link></li>
<li><Link to="/Pune-to-Goa-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Goa Tempo Traveller</Link></li>
<li><Link to="/Pune-to-Mumbai-Tempo-Traveller-on-Rent"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Tempo Traveller on Rent</Link></li>
<li><Link to="/Pune-to-Konkan-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Konkan Tempo Traveller</Link></li>
<li><Link to="/Pune-to-Nashik-Tempo-Traveller-On-Rent"><i className="fa fa-car darkcolor"></i> Pune to Nashik Tempo Traveller On Rent</Link></li>
<li><Link to="/Pune-Darshan-Tempo-Traveller-On-Rent"><i className="fa fa-car darkcolor"></i> Pune Darshan Tempo Traveller On Rent</Link></li>
<li><Link to="/Mini-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pune</Link></li>
<li><Link to="/13-Seater-Tempo-Traveller-on-Rent"><i className="fa fa-car darkcolor"></i> 13 Seater Tempo Traveller on Rent</Link></li>
<li><Link to="/17-Seater-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 17 Seater Tempo Traveller on Rent in Pune</Link></li>
<li><Link to="/20-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 20 Seater Bus on Rent in Pune</Link></li>
<li><Link to="/26-Seater-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 26 Seater Tempo Traveller on Rent in Pune</Link></li>
<li><Link to="/32-Seater-Bus-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 32 Seater Bus Rent in Pune</Link></li>
<li><Link to="/35-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 35 Seater Bus on Rent in Pune</Link></li>
<li><Link to="/45-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 45 Seater Bus on Rent in Pune</Link></li>
<li><Link to="/50-Seater-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 50 Seater Bus On Rent in Pune</Link></li>
<li><Link to="/Bus-Rentals-For-School-Trips-in-Pune"><i className="fa fa-car darkcolor"></i> Bus Rentals For School Trips in Pune</Link></li>
<li><Link to="/Bus-booking-for-wedding-in-Pune"><i className="fa fa-car darkcolor"></i> Bus booking for wedding in Pune</Link></li>
<li><Link to="/Bus-Booking-for-Marriage"><i className="fa fa-car darkcolor"></i> Bus Booking for Marriage</Link></li>
<li><Link to="/Bus-Service-for-Corporate-Pune"><i className="fa fa-car darkcolor"></i> Bus Service for Corporate Pune</Link></li>
<li><Link to="/Bus-on-Rent-For-Event-in-Pune"><i className="fa fa-car darkcolor"></i> Bus on Rent For Event in Pune</Link></li>
<li><Link to="/Bus-Hire-for-Outstation"><i className="fa fa-car darkcolor"></i> Bus Hire for Outstation</Link></li>
<li><Link to="/AC-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> AC Bus On Rent in Pune</Link></li>
<li><Link to="/Pune-Bus-Hire-Rental-Service"><i className="fa fa-car darkcolor"></i> Pune Bus Hire Rental Service</Link></li>
<li><Link to="/Non-Ac-Bus-Rental-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Non Ac Bus Rental Service in Pune</Link></li>
<li><Link to="/Bus-Service-for-Picnic-in-Pune"><i className="fa fa-car darkcolor"></i> Bus Service for Picnic in Pune</Link></li>
<li><Link to="/Pune-to-Aurangabad-Tempo-Traveller-on-Rent"><i className="fa fa-car darkcolor"></i> Pune to Aurangabad Tempo Traveller on Rent</Link></li>
<li><Link to="/Ashtavinayak-Darshan-Tour-Bus-Package-From-Pune"><i className="fa fa-car darkcolor"></i> Ashtavinayak Darshan Tour Bus Package From Pune</Link></li>
<li><Link to="/Pune-to-Rajasthan-Bus-Trip-Package"><i className="fa fa-car darkcolor"></i> Pune to Rajasthan Bus Trip Package</Link></li>
<li><Link to="/Pune-to-Gujarat-Bus-Hire"><i className="fa fa-car darkcolor"></i> Pune to Gujarat Bus Hire</Link></li>
<li><Link to="/Goa-Tour-Package-from-Pune-by-Bus"><i className="fa fa-car darkcolor"></i> Goa Tour Package from Pune by Bus</Link></li>
<li><Link to="/Pune-to-Uttar-Pradesh-bus-on-rent"><i className="fa fa-car darkcolor"></i> Pune to Uttar Pradesh bus on rent</Link></li>
<li><Link to="/Book-Konkan-Darshan-Tour-Packages-from-Pune-by-Bus"><i className="fa fa-car darkcolor"></i> Book Konkan Darshan Tour Packages from Pune by Bus</Link></li>

<li><Link to="/Tempo-Traveller-On-Rent"><i className="fa fa-car darkcolor"></i> Tempo Traveller On Rent</Link></li>

<li><Link to="/Bus-services-for-corporate-in-Pune"><i className="fa fa-car darkcolor"></i> Bus services for corporate in Pune</Link></li>
<li><Link to="/Local-Bus-Hire-In-Pune"><i className="fa fa-car darkcolor"></i> Local Bus Hire In Pune</Link></li>
<li><Link to="/Pune-to-Lonavala-Bus-Tour-Package"><i className="fa fa-car darkcolor"></i> Pune to Lonavala Bus Tour Package</Link></li>
<li><Link to="/Pune-to-Nashik-Bus-on-Rent-Packages"><i className="fa fa-car darkcolor"></i> Pune to Nashik Bus on Rent Packages</Link></li>

                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>
<li><Link to="/Luxury-12-14-Seater-Tempo-Traveller-in-Pune"><i className="fa fa-car darkcolor"></i> Luxury 12,14 Seater Tempo Traveller in Pune</Link></li>
<li><Link to="/Bus-for-Tourist-in-Pune"><i className="fa fa-car darkcolor"></i> Bus for Tourist in Pune</Link></li>
<li><Link to="/Pune-to-Sinhagad-Fort-Bus-on-rent-in-Pune"><i className="fa fa-car darkcolor"></i> Pune to Sinhagad Fort Bus on rent in Pune</Link></li>
<li><Link to="/Pune-to-Bhimashankar-Jyotirlinga-bus-on-Rent"><i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Jyotirlinga bus on Rent</Link></li>
<li><Link to="/Pune-to-Kolhapur-Tempo-Traveller-Rent"><i className="fa fa-car darkcolor"></i> Pune to Kolhapur Tempo Traveller Rent</Link></li>
<li><Link to="/Pune-to-Mumbai-Bus-Hire-for-Tour-Package-From-Pune"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Bus Hire for Tour Package From Pune</Link></li>
<li><Link to="/Sadeteenshaktipeeth-tour-from-pune-by-bus"><i className="fa fa-car darkcolor"></i> Sadeteenshaktipeeth tour from pune by bus</Link></li>
<li><Link to="/Pune-To-Matheran-Tempo-Traveller-Hire-On-Rent"><i className="fa fa-car darkcolor"></i> Pune To Matheran Tempo Traveller Hire On Rent</Link></li>
<li><Link to="/Ac-Tempo-Traveller-Rent-Pune"><i className="fa fa-car darkcolor"></i> Ac Tempo Traveller Rent Pune</Link></li>
<li><Link to="/Bus-Hire-in-Pune-For-Outstation-and-Local"><i className="fa fa-car darkcolor"></i> Bus Hire in Pune For Outstation and Local</Link></li>
<li><Link to="/Book-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Book Bus On Rent in Pune</Link></li>
<li><Link to="/Bharat-Benz-bus-on-Rent-Pune"><i className="fa fa-car darkcolor"></i> Bharat Benz bus on Rent Pune</Link></li>
<li><Link to="/Eicher-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Eicher Bus on Rent in Pune</Link></li>
<li><Link to="/Pune-to-Mahabaleshwar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Cab</Link></li>
<li><Link to="/Pune-to-Bhimashankar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Cab</Link></li>

                      <li><Link to="/Pune-to-Konkan-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Konkan Darshan Cab</Link></li>
<li><Link to="/Online-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Online Cab Booking Pune</Link></li>

<li><Link to="/Innova-Crysta-Cab-Booking"><i className="fa fa-car darkcolor"></i> Innova Crysta Cab Booking</Link></li>
<li><Link to="/Ashtavinayak-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Ashtavinayak Darshan Cab</Link></li>
<li><Link to="/Pune-to-Lonavala-Cab"><i className="fa fa-car darkcolor"></i> Pune to Lonavala Cab</Link></li>
<li><Link to="/Pune-to-outstation-cab"><i className="fa fa-car darkcolor"></i> Pune to outstation cab</Link></li>
<li><Link to="/Ertiga-Cab"><i className="fa fa-car darkcolor"></i> Ertiga Cab</Link></li>
<li><Link to="/Car-Hire-in-Pune"><i className="fa fa-car darkcolor"></i> Car Hire in Pune</Link></li>
<li><Link to="/Swift-Dzire-On-Rent-Pune"><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent Pune</Link></li>
<li><Link to="/Sedan-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Sedan Cab Service in Pune</Link></li>
<li><Link to="/7-Seater-car-on-rent-in-Pune"><i className="fa fa-car darkcolor"></i> 7 Seater car on rent in Pune</Link></li>
<li><Link to="/Etios-Cab-for-Outstation-in-Pune"><i className="fa fa-car darkcolor"></i> Etios Cab for Outstation in Pune</Link></li>
<li><Link to="/Pune-to-Jejuri-Cab"><i className="fa fa-car darkcolor"></i> Pune to Jejuri Cab</Link></li>
<li><Link to="/Pune-Darshan-Package"><i className="fa fa-car darkcolor"></i> Pune Darshan Package</Link></li>
<li><Link to="/Pune-to-Indore-Cab"><i className="fa fa-car darkcolor"></i> Pune to Indore Cab</Link></li>
<li><Link to="/Pune-to-Gujarat-Cab"><i className="fa fa-car darkcolor"></i> Pune to Gujarat Cab</Link></li>
<li><Link to="/Pune-to-Rajasthan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Rajasthan Cab</Link></li>
<li><Link to="/Pune-to-Bangalore-Cab"><i className="fa fa-car darkcolor"></i> Pune to Bangalore Cab</Link></li>
<li><Link to="/Pune-to-Shirdi-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cab</Link></li>
<li><Link to="/Book-taxi-in-Pune"><i className="fa fa-car darkcolor"></i> Book taxi in Pune</Link></li>
<li><Link to="/Pune-to-Mahabaleshwar-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Taxi</Link></li>
<li><Link to="/Pune-to-Goa-Cab"><i className="fa fa-car darkcolor"></i> Pune to Goa Cab</Link></li>
<li><Link to="/Pune-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Cab</Link></li>
<li><Link to="/Pune-to-Aurangabad-Cab"><i className="fa fa-car darkcolor"></i> Pune to Aurangabad Cab</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Pune"><i className="fa fa-car darkcolor"></i> Corporate Cab Services in Pune</Link></li>
<li><Link to="/Wedding-Car-Rental-Pune"><i className="fa fa-car darkcolor"></i> Wedding Car Rental Pune</Link></li>

                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
<li><Link to="/Cab-Service-in-Pimpri-Chinchwad"><i className="fa fa-car darkcolor"></i> Cab Service in Pimpri Chinchwad</Link></li>
<li><Link to="/Pan-India-Bus-Cab-Service-Pune"><i className="fa fa-car darkcolor"></i> Pan India Bus & Cab Service Pune</Link></li>
<li><Link to="/Pune-to-Mysore-Ooty-Bus-Tour-Package"><i className="fa fa-car darkcolor"></i> Pune to Mysore Ooty Bus Tour Package</Link></li>
<li><Link to="/Pune-to-Madhya-Pradesh-Bus-for-Trip"><i className="fa fa-car darkcolor"></i> Pune to Madhya Pradesh Bus for Trip</Link></li>
                  
                  <li><Link to="/Bus-On-Rent-Pune"><i className="fa fa-bus darkcolor"></i> Bus On Rent Pune</Link></li>
<li><Link to="/Pune-Bus-Hire"><i className="fa fa-bus darkcolor"></i> Pune Bus Hire</Link></li>
<li><Link to="/Bus-Hire-in-Pune"><i className="fa fa-bus darkcolor"></i> Bus Hire in Pune</Link></li>
<li><Link to="/Bus-Service-Pune"><i className="fa fa-bus darkcolor"></i> Bus Service Pune</Link></li>
<li><Link to="/Rent-a-Bus-Pune"><i className="fa fa-bus darkcolor"></i> Rent a Bus Pune</Link></li>
<li><Link to="/40-Seater-Bus-On-Rent-in-Pune"><i className="fa fa-bus darkcolor"></i> 40 Seater Bus On Rent in Pune</Link></li>
<li><Link to="/25-Seater-Bus-On-Rent-in-Pune"><i className="fa fa-bus darkcolor"></i> 25 Seater Bus On Rent in Pune</Link></li>
<li><Link to="/Mini-Bus-Rental-Pune"><i className="fa fa-bus darkcolor"></i> Mini Bus Rental Pune</Link></li>
<li><Link to="/Urbania-On-Rent-in-Pune"><i className="fa fa-bus darkcolor"></i> Urbania On Rent in Pune</Link></li>
<li><Link to="/Urbania-On-Rent-Pune"><i className="fa fa-bus darkcolor"></i> Urbania On Rent Pune</Link></li>
<li><Link to="/Tempo-Traveller-Rental-Pune"><i className="fa fa-bus darkcolor"></i> Tempo Traveller Rental Pune</Link></li>
<li><Link to="/Bus-Rentals-for-Corporate-Events"><i className="fa fa-bus darkcolor"></i> Bus Rentals for Corporate Events</Link></li>
<li><Link to="/20-Seater-Tempo-Traveller-On-Rent-in-Pune"><i className="fa fa-bus darkcolor"></i> 20 Seater Tempo Traveller On Rent in Pune</Link></li>
<li><Link to="/26-Seater-Bus-On-Rent-in-Pune"><i className="fa fa-bus darkcolor"></i> 26 Seater Bus On Rent in Pune</Link></li>
<li><Link to="/Urbania-On-Rent-in-Pimpri-Chinchwad"><i className="fa fa-bus darkcolor"></i> Urbania On Rent in Pimpri Chinchwad</Link></li>
<li><Link to="/Innova-Crysta-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Pune</Link></li>
<li><Link to="/Mini-Bus-Hire-in-Pune"><i className="fa fa-bus darkcolor"></i> Mini Bus Hire in Pune</Link></li>
<li><Link to="/Tempo-Traveller-On-Rent-in-Pimpri-Chinchwad"><i className="fa fa-bus darkcolor"></i> Tempo Traveller On Rent in Pimpri Chinchwad</Link></li>
<li><Link to="/Bus-Rental-for-Corporate-Events-in-Pune"><i className="fa fa-bus darkcolor"></i> Bus Rental for Corporate Events in Pune</Link></li>
<li><Link to="/Wedding-Bus-Rental-Services-in-Pune"><i className="fa fa-bus darkcolor"></i> Wedding Bus Rental Services in Pune</Link></li>
<li><Link to="/Bus-Rental-Pune"><i className="fa fa-bus darkcolor"></i> Bus Rental Pune</Link></li>
<li><Link to="/Mini-Bus-Rentals-Pune"><i className="fa fa-bus darkcolor"></i> Mini Bus Rentals Pune</Link></li>
<li><Link to="/Innova-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova On Rent in Pune</Link></li>


<li><Link to="/Urbania-Hire-for-Corporate-Events-in-Pune"><i className="fa fa-bus darkcolor"></i> Urbania Hire for Corporate Events in Pune</Link></li>
<li><Link to="/17-Seater-Urbania-on-Rent-in-Pune"><i className="fa fa-bus darkcolor"></i> 17 Seater Urbania on Rent in Pune</Link></li>
<li><Link to="/14-Seater-Urbania-on-Rent-in-Pune"><i className="fa fa-bus darkcolor"></i> 14 Seater Urbania on Rent in Pune</Link></li>
<li><Link to="/Urbania-on-Rent-in-Kharadi"><i className="fa fa-bus darkcolor"></i> Urbania on Rent in Kharadi</Link></li>
<li><Link to="/Urbania-on-Rent-in-Hadapsar"><i className="fa fa-bus darkcolor"></i> Urbania on Rent in Hadapsar</Link></li>
<li><Link to="/Urbania-on-Rent-in-Kothrud"><i className="fa fa-bus darkcolor"></i> Urbania on Rent in Kothrud</Link></li>
<li><Link to="/Urbania-on-Rent-in-Koregaon-Park"><i className="fa fa-bus darkcolor"></i> Urbania on Rent in Koregaon Park</Link></li>
<li><Link to="/Urbania-for-Wedding-Events-in-Pune"><i className="fa fa-bus darkcolor"></i> Urbania for Wedding Events in Pune</Link></li>
<li><Link to="/Urbania-for-Pune-to-Mahabaleshwar-Hire"><i className="fa fa-bus darkcolor"></i> Urbania for Pune to Mahabaleshwar Hire</Link></li>
<li><Link to="/Urbania-for-Pune-to-Goa-Tour-Package"><i className="fa fa-bus darkcolor"></i> Urbania for Pune to Goa Tour Package</Link></li>
<li><Link to="/Pune-to-Shirdi-Urbania-On-Rent"><i className="fa fa-bus darkcolor"></i> Pune to Shirdi Urbania On Rent</Link></li>
<li><Link to="/Luxury-Force-Urbania-On-Rent-in-Pune"><i className="fa fa-bus darkcolor"></i> Luxury Force Urbania On Rent in Pune</Link></li>
<li><Link to="/Urbania-Hire-for-Picnic-in-Pune"><i className="fa fa-bus darkcolor"></i> Urbania Hire for Picnic in Pune</Link></li>

                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Ruturaj Enterprises</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


